/** D-306 - Israeli ID number: exactly 9 digits and a valid check digit (the server checks again). */
export function normalizeIsraeliId(raw: string): string {
  const id = (raw ?? '').trim();
  return /^\d{5,8}$/.test(id) ? id.padStart(9, '0') : id; // 5-8 digits: leading zeros, as the standard says
}

export function isValidIsraeliId(raw: string): boolean {
  const id = normalizeIsraeliId(raw);
  if (!/^\d{9}$/.test(id) || id === '000000000') return false;
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    let n = Number(id[i]) * ((i % 2) + 1);
    if (n > 9) n -= 9;
    sum += n;
  }
  return sum % 10 === 0;
}

/** Card payload of the D-305/D-306 fields. Empty -> null on edit (clears), omitted on create. */
export function cardExtrasPayload(
  form: { idNumber: string; phoneSecondary: string; travelPerDay: string; travelMonthlyCap: string },
  opts: { editing: boolean; canEditTravel: boolean }
): Record<string, string | number | null> {
  const out: Record<string, string | number | null> = {};
  const put = (key: string, value: string | number | null) => {
    if (value === null || value === '') {
      if (opts.editing) out[key] = null;
    } else {
      out[key] = value;
    }
  };
  put('id_number', normalizeIsraeliId(form.idNumber));
  put('phone_secondary', form.phoneSecondary.trim());
  if (opts.canEditTravel) {
    put('travel_per_day', form.travelPerDay.trim() === '' ? null : Number(form.travelPerDay));
    put('travel_monthly_cap', form.travelMonthlyCap.trim() === '' ? null : Number(form.travelMonthlyCap));
  }
  return out;
}
